import configure from "configure"
import React from "react"
import { Link } from "react-router-dom"

export const getContractServiceColumns = (updateService, deleteContractService) => [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Contract Services",
    accessor: "service",
  },
  {
    Header: "Action",
    accessor: "action",
    Cell: ({ row }) => (
      <div>
        <a
          onClick={() => updateService(row.original.id, row.original.service)}
          className="btn btn-sm me-1 btn-outline-secondary"
        >
          <i className="fas fa-pencil-alt"></i>
        </a>
        <a
          onClick={() => deleteContractService(row.original.id)}
          className="btn btn-sm btn-danger"
        >
          <i className="fas fa-trash-alt"></i>
        </a>
      </div>
    ),
  },
]

export const getContractTypeColumns = (updateType, deleteContractType) => [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Contract Type Name",
    accessor: "contract_type",
  },
  {
    Header: "Action",
    accessor: "action",
    Cell: cellProps => {
      return (
        <div>
          <a
            onClick={() => {
              updateType(cellProps.row.original.id, cellProps.row.original.contract_type)
            }}
            className="btn btn-sm me-1 btn-outline-secondary"
          >
            <i className="fas fa-pencil-alt"></i>
          </a>
          <a onClick={() => {
            deleteContractType(cellProps.row.original.id)
          }} className="btn btn-sm  btn-danger">
            <i className="fas fa-trash-alt"></i>
          </a>
        </div>
      )
    },
  },
]

export const getContractTemplateColumns = (deleteContractService) => [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Template Name",
    accessor: "name",
  },
  {
    Header: "Action",
    accessor: "action",
    Cell: cellProps => {
      return (
        <div>
          <Link
            to={`${configure.appUrl}setting/edit-contract-template/${cellProps.row.original.id}`}
            className="btn btn-sm me-1 btn-outline-secondary"
          >
            <i className="fas fa-pencil-alt"></i>
          </Link>
          <a
            onClick={() => {
              deleteContractService(cellProps.row.original.id)
            }}
            className="btn btn-sm  btn-danger"
          >
            <i className="fas fa-trash-alt"></i>
          </a>
        </div>
      )
    },
  },
]

export const getStaffTemplateColumns = deleteContractService => [
  {
    Header: <span style={{ textAlign: "center" }}>ID</span>,
    accessor: "id",
    className: "col-md-1 text-center",
    Cell: ({ value }) => <span style={{ textAlign: "center" }}>{value}</span>,
  },
  {
    Header: "Template Name",
    accessor: "name",
    className: "col-md-4",
    Cell: ({ value }) => <span>{value}</span>,
  },
  {
    Header: "Template Type",
    accessor: "typeLabel",
    Cell: ({ value }) => (
      <span style={{ display: "block", width: 300 }}>{value}</span>
    ),
  },
  {
    Header: "Action",
    accessor: "action",
    width: 200,
    classNames: "align-items-center",
    Cell: cellProps => {
      return (
        <div style={{ display: "block", width: 100, textAlign: "center" }}>
          <Link
            to={`${configure.appUrl}setting/edit-letters-template/${cellProps.row.original.id}`}
            className="btn btn-sm me-1 btn-outline-secondary"
          >
            <i className="fas fa-pencil-alt"></i>
          </Link>
          <a
            onClick={() => {
              deleteContractService(cellProps.row.original.id)
            }}
            className="btn btn-sm  btn-danger"
          >
            <i className="fas fa-trash-alt"></i>
          </a>
        </div>
      )
    },
  },
]
  